export * from './Constants';
export { default as Constants } from './Constants';
export { default as getEntityRanges } from './getEntityRanges';
export { default as getSelectedBlocks } from './getSelectedBlocks';
export { default as selectionContainsEntity } from './selectionContainsEntity';
export { default as callModifierForSelectedBlocks } from './callModifierForSelectedBlocks';


//////////////////
// WEBPACK FOOTER
// ../draft-js-utils/esm/main.js
// module id = 145
// module chunks = 25